import { useInternationalization } from '@progress/kendo-react-intl';
import { useTranslation } from 'react-i18next';
import { useContextSelector } from 'use-context-selector';
import { ShoppingCartContext } from './ShoppingCartContext';

const ShoppingCartSelectedTotals = () => {
  const { t } = useTranslation();
  const intl = useInternationalization();

  const totalQty = useContextSelector(
    ShoppingCartContext,
    (context) => context.selectedGridTotals.totalQty
  );
  const totalAmount = useContextSelector(
    ShoppingCartContext,
    (context) => context.selectedGridTotals.totalAmount
  );

  const formattedTotalAmount = intl.format('{0:c2}', Math.abs(totalAmount));
  const displayTotalAmount = totalAmount < 0 ? `(${formattedTotalAmount})` : formattedTotalAmount;

  return (
    <div
      data-testid="shopping-cart-selected-totals"
      className="flex shrink-0 flex-col items-end whitespace-nowrap text-xs font-semibold leading-5"
    >
      <span>
        {t('Total Selected Qty')} : {totalQty}
      </span>
      <span>
        {t('Total Selected Amt')} : {displayTotalAmount}
      </span>
    </div>
  );
};

export default ShoppingCartSelectedTotals;
